module.exports = __webpack_public_path__ + "img/carshinaused_15.56c22403.jpg";